const AccessLevelProtectedContent = ({ accessLevel, children }) => {
  const userAccessList = JSON.parse(
    localStorage.getItem("authUser")
  )?.get_securityauthcapability_list;

  //User should have all accessLevel to see the component, otherwise return null
  const hasAccess = accessLevel?.every((item) =>
    userAccessList?.includes(item)
  );
  // show what access is missing
  const missingAccess = accessLevel?.filter(
    (item) => !userAccessList?.includes(item)
  );
  if (!hasAccess) return null;
  return <>{children}</>;
};

export default AccessLevelProtectedContent;
